module.exports = __webpack_public_path__ + "img/australia-cardiovascular-diseases-male.72735235.png";